import { render, staticRenderFns } from "./childrencoin.vue?vue&type=template&id=842ba254&scoped=true"
import script from "./childrencoin.vue?vue&type=script&lang=js"
export * from "./childrencoin.vue?vue&type=script&lang=js"
import style0 from "./childrencoin.vue?vue&type=style&index=0&id=842ba254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842ba254",
  null
  
)

export default component.exports